<div #tooltipOptionsRef (click)="isOpened = !isOpened" class="options-tooltip">
    <ng-content select="[tooltipTrigger]"></ng-content>

    <ul [class.opened]="isOpened" class="options-tooltip-menu" [ngStyle]="{ top: top, right: right }">
        <ng-content select="[tooltipMenu]"></ng-content>
    </ul>
</div>
